// extracted by mini-css-extract-plugin
module.exports = {"section":"Divider_section__IuIe8","label":"Divider_label__Eu2My","title":"Divider_title__nMWC3","content":"Divider_content__96qhK"};